import { render, staticRenderFns } from "./AppNotificationListWrapper.vue?vue&type=template&id=bd39030a&scoped=true&"
import script from "./AppNotificationListWrapper.vue?vue&type=script&lang=js&"
export * from "./AppNotificationListWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AppNotificationListWrapper.vue?vue&type=style&index=0&id=bd39030a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd39030a",
  null
  
)

export default component.exports